// daworks.io 공개 홈페이지 전용 스크립트
// 관리 시스템 번들(app.js, jQuery)과 분리 — 공개 페이지는 vanilla JS만 사용한다.

document.addEventListener('DOMContentLoaded', () => {
	// 모바일 네비게이션 토글 (BS4 collapse의 jQuery 의존을 피하기 위한 자체 구현)
	const toggler = document.querySelector('.site-nav-toggler');
	const nav = document.querySelector('#site-nav-menu');
	if (toggler && nav) {
		toggler.addEventListener('click', () => {
			nav.classList.toggle('show');
			toggler.setAttribute('aria-expanded', nav.classList.contains('show'));
		});
	}
});
